/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Open a Klaviyo form from any link href'd "#klaviyo-open-<formId>".
  // Shopify's link picker rejects javascript: hrefs, so the form id rides
  // in as a plain anchor and we intercept the click here.
  document.addEventListener('click', function(event) {
    var link = event.target.closest && event.target.closest('a[href*="#klaviyo-open-"]');
    if (!link) return;
    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', link.getAttribute('href').split('#klaviyo-open-')[1]]);
  });

})();
